export enum UserAction {
  createUser = "createUser",
  editUser = "editUser",
  deleteUser = "deleteUser",
}
